import type { Article, ArticleContent } from "@/features/knowledge-bank/types";
import type { Locale } from "@/i18n/config";

import { hurFungerarBostadskoer } from "@/features/knowledge-bank/articles/hur-fungerar-bostadskoer";

/**
 * Alla artiklar i kunskapsbanken. Ny artikel: skapa en fil i ./articles/
 * (kopiera en befintlig), lägg till den här och sätt status "published" när
 * texten är granskad.
 */
const ALL_ARTICLES: Article[] = [hurFungerarBostadskoer];

const showDrafts = process.env.NODE_ENV === "development";

export function getArticles(): Article[] {
  return ALL_ARTICLES.filter((article) => article.status === "published" || showDrafts).sort(
    (a, b) => b.publishedAt.localeCompare(a.publishedAt),
  );
}

export function getArticle(slug: string): Article | undefined {
  return getArticles().find((article) => article.slug === slug);
}

export function hasArticles(): boolean {
  return getArticles().length > 0;
}

/** Engelsk text om den finns, annars den svenska. */
export function articleContent(article: Article, locale: Locale): ArticleContent {
  return (locale === "en" && article.content.en) || article.content.sv;
}

export function hasTranslation(article: Article, locale: Locale): boolean {
  return locale === "sv" || Boolean(article.content.en);
}
